import { TradeMethodParsingsPage } from 'features/trade-methods';

export const AdminTradeMethodParsingsPage = () => <TradeMethodParsingsPage />;
